export default __webpack_public_path__ + "static/media/stockimage.8143301f.svg";